import React, { useState } from 'react';
import { Row, Col, Button, Form, Image, Card, Container } from 'react-bootstrap';
import './AddContacts.css';
import { CreateContacts } from '../../../helpers/api';
// import { Card, Dropdown } from 'react-bootstrap';
const AddContacts: React.FC = () => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [group_name, setGroup] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);

    const handleSave = async () => {
        if (!name || !phone) return alert('Name and phone are required.');
        if (!file) return alert('Profile picture is required.');

        try {
            await CreateContacts({
                name: name,
                mobile_no: phone,
                profile: file,
                group_name: group_name
            });

            setName('');
            setPhone('');
            setFile(null);
            setPreview(null);
        } catch (err) {
            alert('Error creating contact');
            console.error(err);
        }
    };

    const handleCancel = () => {
        setName('');
        setPhone('');
        setFile(null);
        setPreview(null);
    };

    const handleProfilePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0];
        if (selected) {
            setFile(selected);

            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result as string);
            reader.readAsDataURL(selected);
        }
    };

    return (
        <>
            <Container fluid className="d-flex justify-content-center mt-1">
                <Card className="add-contact shadow-lg" 
                style={{ width: '60%',  }}
                >
                    {/* <h5 className="mb-0">Add New Contact</h5> */}

                    {/* <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Add New Contact</h5>
                    </Card.Header> */}

                    <Card.Body className="p-3 ">
                        <h4 className='d-flex justify-content-center mt-1' >Add Contact</h4>
                        {/* Profile picture */}
                        <Row className="mt-4 mb-1 justify-content-center">
                            <Col md={10}>
                                <Form.Group controlId="formProfilePic">
                                    <Form.Label>Profile Picture</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleProfilePicChange}
                                        className="mt-2"
                                    />
                                </Form.Group>

                                {preview && (
                                    <Image
                                        src={preview}
                                        roundedCircle
                                        width={100}
                                        height={100}
                                        className="mt-3 border"
                                    />
                                )}
                            </Col>
                        </Row>

                        {/* Name */}
                        <Row className="mb-1 justify-content-center">
                            <Col md={10}>
                                <Form.Group controlId="formName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Phone */}
                        <Row className="mb-1 justify-content-center">
                            <Col md={10}>
                                <Form.Group controlId="formPhone">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter phone number"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Group */}
                        <Row className="mb-1 justify-content-center">
                            <Col md={10}>
                                <Form.Group controlId="formGroup">
                                    <Form.Label>Group Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter group name"
                                        value={group_name}
                                        onChange={(e) => setGroup(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Buttons */}
                        <Row>
                            <Col className="d-flex justify-content-center gap-2">
                                <Button variant="secondary" onClick={handleCancel}>
                                    Cancel
                                </Button>
                                <Button variant="primary" onClick={handleSave}>
                                    Save
                                </Button>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </Container>

        </>
    );
};

export default AddContacts;
